import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../css/DashboardRecent.css";

// Optional local placeholder when product_image is null
import placeholderImg from "../assets/Dashboard/food2.png";

const DashboardRecent = ({ data = [] }) => {
  const navigate = useNavigate();

  // 🔄 Format recent orders for UI
  const orders = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map((item) => ({
      id: item.id,
      name: item.product_name,
      weight: item.quantity,
      price: item.current_price,
      originalPrice: item.original_price,
      date: item.order_date,
      status: item.status,
      imageUrl: item.product_image || placeholderImg,
      email: item.customer_email,
    }));
  }, [data]);

  const handleOrderClick = (order) => {
    navigate("/recent-order-details", { state: { order } });
  };

  if (!orders.length) {
    return (
      <motion.div
        className="dashboard-main-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <div className="Recent-orders-container">
          <h2 className="Recent-orders-title">Recent Orders</h2>
          <p>No recent orders available</p>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="dashboard-main-container"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="Recent-orders-container">
        <motion.h2
          className="Recent-orders-title"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          Recent Orders
        </motion.h2>

        <motion.div
          className="Recent-order-list"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.1,
              },
            },
          }}
        >
          {orders.map((order, index) => (
            <motion.div
              key={order.id}
              className="Recent-order-item"
              onClick={() => handleOrderClick(order)}
              style={{ cursor: "pointer" }}
              variants={{
                hidden: { opacity: 0, y: 15 },
                visible: { opacity: 1, y: 0 },
              }}
              whileHover={{
                scale: 1.02,
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              <div className="Recent-product-info">
                <motion.img
                  src={order.imageUrl}
                  alt={order.name}
                  className="Recent-product-image"
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.4 }}
                />
                <span>{order.name}</span>
              </div>

              <div className="Recent-order-details">
                <span>{order.weight}</span>
              </div>

              <div className="Recent-price-container">
                <motion.span
                  className="Recent-price"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  Rs&nbsp;{order.price}
                </motion.span>

                {order.originalPrice && (
                  <span className="Recent-original-price">
                    Rs {order.originalPrice}
                  </span>
                )}
              </div>

              <div className="Recent-order-details">
                <span>{order.date}</span>
              </div>

              <motion.div
                className={`Recent-status-badge ${order.status.toLowerCase()}`}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
              >
                {order.status}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default DashboardRecent;
